import React, { useEffect, useState } from 'react';
import BarChart from './BarChart';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';

const BarChartFaultSection = ({ packType, filterdata }) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [faultVoltageChartData, setFaultVoltageChartData] = useState([])
  const [faultSOCChartData, setFaultSOCChartData] = useState([])
  const [faultVoltageChartLoader, setFaultVoltageChartLoader] = useState(false)
  const [faultSOCChartLoader, setFaultSOCChartLoader] = useState(false)


  useEffect(() => {
    setFaultVoltageChartLoader(true)
    fetchData(
      {
        url: API_URL_MAIN + `battery_digital_twin/fault_voltage`,
        body: { filterdata: {...filterdata},packType },
      },
      (data) => {
        if (data) {
          setFaultVoltageChartData(data?.histogramData)
        } else {
          setFaultVoltageChartData([])
        }
        setFaultVoltageChartLoader(false)
      }
    );
  }, [filterdata, packType])


  useEffect(() => {
    setFaultSOCChartLoader(true)
    fetchData(
      {
        url: API_URL_MAIN + `battery_digital_twin/fault_SOC`,
        body: { filterdata: {...filterdata},packType },
      },
      (data) => {
        if (data) {
          setFaultSOCChartData(data?.histogramData)
        } else {
          setFaultSOCChartData([])
        }
        setFaultSOCChartLoader(false)
      }
    );
  }, [filterdata, packType])

  return (
    <div className="row g-3 mb-4">
      {/* left side histogram */}
      <div className="col-12 col-md-6 ps-0">
        <div className="card p-2">
          <div className="row">
            <div className="col d-flex justify-content-end">
              <div className="col-12 col-sm-6 col-md-5 h5 text-center fw-bolder my-2">
               Fault Voltage
              </div>
            </div>
          </div>
          <BarChart data={faultVoltageChartData} yLabel="" xLabel="" isLoading={faultVoltageChartLoader} noDataText="0 faults were identified during analysis!" />
        </div>
      </div>


      {/* Right side histogram */}
      <div className="col-12 col-md-6 pr-0">
        <div className="card p-2">
          <div className="row">
            <div className="col d-flex justify-content-end">
              <div className="col-12 col-sm-6 col-md-5 h5 text-center fw-bolder my-2">
               Fault SOC
              </div>
            </div>
          </div>
          <BarChart data={faultSOCChartData} yLabel="" xLabel="" isLoading={faultSOCChartLoader} noDataText="0 faults were identified during analysis!"/>
        </div>
      </div>
    </div>
  );
}

export default BarChartFaultSection;
